import React, { Fragment } from "react";
import "./Navbar.css";
import CodeChefIcon from "./Icons/CodeChefIcon"

const mailDetails = {
  email: "gauravsachar29@gmail.com",
  subject: "Interested in your profile.",
  body: "Hello! Gaurav, We loved your profile...",
  cc: "sachargaurav123.ils@gmail.com",
};
const SideBars = () => {
  return (
    <Fragment>
      <div className="leftSideBar">
        <li>
          <a
            rel="noreferrer"
            target="_blank"
            href="https://www.linkedin.com/in/gaurav-sachar-7342911b2/"
            className="call"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="white"
              className="bi bi-linkedin"
              viewBox="0 0 16 16"
            >
              <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
            </svg>
          </a>
        </li>
        <li>
          <a
            href="https://www.duolingo.com/profile/gaurav_sachar_"
            rel="noreferrer"
            target="_blank"
            className="call"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="24"
              height="24"
              viewBox="0 0 48 48"
            >
              <path
                fill="#7cb342"
                d="M38,6H10c-2.209,0-4,1.791-4,4v28c0,2.209,1.791,4,4,4h28c2.209,0,4-1.791,4-4V10 C42,7.791,40.209,6,38,6z"
              ></path>
              <path
                fill="#aeea00"
                d="M42,18v11.5c-1.43,2.67-4.26,4.5-7.5,4.5c-3.82,0-7.05-2.52-8.13-6h-4.74c-1.08,3.48-4.31,6-8.13,6 c-3.24,0-6.07-1.83-7.5-4.5V18c0-2,0.99-6,3-6c1,0,1.94,1.44,2.52,2.1C11.55,13.21,11.21,10,13,10c3,0,5,8,11,8s8-8,11-8 c1.79,0,1.45,3.21,1.48,4.1C37.06,13.44,38,12,39,12C41.01,12,42,16,42,18z"
              ></path>
              <path
                fill="#fafafa"
                d="M34.5,31L34.5,31c-3.038,0-5.5-2.462-5.5-5.5v-3c0-3.038,2.462-5.5,5.5-5.5h0 c3.038,0,5.5,2.462,5.5,5.5v3C40,28.538,37.538,31,34.5,31z"
              ></path>
              <path
                fill="#616161"
                d="M36,22.5v3c0,1.38-1.12,2.5-2.5,2.5S31,26.88,31,25.5v-2.59c0.16,0.06,0.32,0.09,0.5,0.09 c0.83,0,1.5-0.67,1.5-1.5c0-0.51-0.25-0.96-0.64-1.22C32.7,20.1,33.09,20,33.5,20C34.88,20,36,21.12,36,22.5z"
              ></path>
              <path
                fill="#fafafa"
                d="M13.5,31L13.5,31C10.462,31,8,28.538,8,25.5v-3c0-3.038,2.462-5.5,5.5-5.5h0 c3.038,0,5.5,2.462,5.5,5.5v3C19,28.538,16.538,31,13.5,31z"
              ></path>
              <path
                fill="#616161"
                d="M17,22.5v3c0,1.38-1.12,2.5-2.5,2.5S12,26.88,12,25.5v-2.59c0.16,0.06,0.32,0.09,0.5,0.09 c0.83,0,1.5-0.67,1.5-1.5c0-0.51-0.25-0.96-0.64-1.22C13.7,20.1,14.09,20,14.5,20C15.88,20,17,21.12,17,22.5z"
              ></path>
              <circle cx="24" cy="30" r="3" fill="#ef6c00"></circle>
              <path
                fill="#f9a825"
                d="M24,26c-2.209,0-4,1.791-4,4l4,1l4-1C28,27.791,26.209,26,24,26z"
              ></path>
              <path
                fill="#ffd54f"
                d="M24.5,29h-1c-0.552,0-1-0.448-1-1v0c0-0.552,0.448-1,1-1h1c0.552,0,1,0.448,1,1v0 C25.5,28.552,25.052,29,24.5,29z"
              ></path>
            </svg>
          </a>
        </li>

        <li>
          <a
            href="https://codedamn.com/user/megauravsachar"
            className="codedamn"
            target="_blank"
            rel="noreferrer"
          >
            C
          </a>
        </li>

        <li>
          <a
            href="https://www.codechef.com/users/gaurav_sachar"
            rel="noreferrer"
            target="_blank"
            className="call"
          >
            <CodeChefIcon width={30} height={30}/>
          </a>
        </li>

        <li>
          <a
            href="tel:+918920626111"
            rel="noreferrer"
            target="_parent"
            className="call"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="white"
              className="bi bi-telephone-fill"
              viewBox="0 0 16 16"
            >
              <path d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
            </svg>
          </a>
        </li>

        <hr className="leftHR" />
      </div>
      <div className="rightSideBar">
        <a
          className="mymail"
          href={`mailto:${mailDetails.email}?subject=${mailDetails.subject}&body=${mailDetails.body}&cc=${mailDetails.cc}`}
          // href={`https://mail.google.com/mail/?view=cm&fs=1&to=${mailDetails.email}&cc=sachargaurav123.ils@gmail.com&su=${mailDetails.subject}&body=${mailDetails.body}`}
          target="_parent"
        >
          gauravsachar29@gmail.com
        </a>
        <hr className="leftHR" />
      </div>
    </Fragment>
  );
};

export default SideBars;
